<template>
  <div 
    class="h-full flex flex-col bg-gray-lightest overflow-auto"
    :class="{
      'w-full overflow-hidden': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter),
    }"
  >
    <div 
      v-if="lay"
      class="flex p-r-6"
      :class="{
        'flex-col': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter)
      }"
    >
      <div 
        class="lay_sidebar flex-shrink-0 p-x-6 p-y-5 box-border"
        :class="{
          'w-full flex items-center': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter)
        }"
      >
        <h1 class="fz20 fw500">Edit LayTime</h1>
      
        <label 
          class="block"
          :class="{
            'm-t-4': !$route.meta.isCharter || (!smallScreen && !$route.meta.isCharter),
            'flex items-center m-l-auto': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter)
          }"
        >
          <p class="m-r-3 fz13 text-gray-text whitespace-nowrap">Demurage Rate</p>
          <input 
            type="number" 
            class="block-input_content bg-white" 
            :class="{
              'm-t-1': !$route.meta.isCharter || (!smallScreen && !$route.meta.isCharter),
            }"
            v-model="lay.demurrage_rate"
          >
        </label>

        <label 
          class="block"
          :class="{
            'm-t-4': !$route.meta.isCharter || (!smallScreen && !$route.meta.isCharter),
            'flex items-center m-l-8': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter)
          }"
        >
          <p class="m-r-3 fz13 text-gray-text whitespace-nowrap">Dispatch Rate</p>
          <input 
            type="number" 
            class="block-input_content bg-white" 
            :class="{
              'm-t-1': !$route.meta.isCharter || (!smallScreen && !$route.meta.isCharter),
            }"
            v-model="lay.dispatch_rate"
          >
        </label>
      </div>
      <div 
        class="w-full box-border p-t-5"
      >
        <div 
          class="flex rounded-lg bg-white shadow p-l-6 p-r-6 p-t-4 p-b-5 block-ports flex justify-between"
          :class="{
            'm-r-6 p-l-6 p-r-4': !$route.meta.isCharter || (!smallScreen && !$route.meta.isCharter),
            'm-x-6': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter)
          }"
        >
          <div class="loading position-relative">
            <div class="no-ports" v-if="!loading_ports.length">
              <svg width="141" height="140" viewBox="0 0 141 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M106.978 81.1816H106.976M70.1108 2.83789C57.4953 2.83789 45.3331 7.54194 36.0004 16.0307C26.6681 24.5192 20.8367 36.1833 19.6446 48.7428C18.4534 61.3018 21.9879 73.8547 29.557 83.9462L68.268 135.561C68.7031 136.141 69.3861 136.483 70.1114 136.483C70.8366 136.483 71.5196 136.141 71.9547 135.561L110.666 83.9462C118.235 73.8539 121.769 61.301 120.578 48.7428C119.386 36.1839 113.554 24.5197 104.222 16.0307C94.8893 7.5422 82.7272 2.83789 70.1119 2.83789H70.1108Z" stroke="#BDCBD6" stroke-width="2"/>
                <path d="M68.3969 35.5363L67.6838 36.2373L67.6838 36.2374L68.3969 35.5363ZM68.3969 30.9045L67.6838 30.2034L67.6838 30.2035L68.3969 30.9045ZM72.9508 30.9045L73.6639 30.2035L73.6638 30.2034L72.9508 30.9045ZM72.9508 35.5363L73.6638 36.2374L73.6639 36.2373L72.9508 35.5363ZM50.951 57.7835L51.5489 56.9819C51.3298 56.8185 51.0534 56.7519 50.784 56.7975C50.5146 56.8432 50.2755 56.9971 50.1225 57.2235L50.951 57.7835ZM56.7275 71.9682L56.0144 72.6692L56.0144 72.6693L56.7275 71.9682ZM84.62 71.9682L85.333 72.6693L85.3331 72.6692L84.62 71.9682ZM90.3965 57.7835L91.2485 57.2599C91.1042 57.0252 90.8696 56.8604 90.5998 56.8044C90.3301 56.7484 90.0492 56.8061 89.8234 56.964L90.3965 57.7835ZM45.695 63.7737C45.3857 64.2312 45.5059 64.8529 45.9634 65.1622C46.421 65.4714 47.0426 65.3512 47.3519 64.8937L45.695 63.7737ZM56.3907 63.0883C56.8334 63.4185 57.46 63.3273 57.7902 62.8846C58.1204 62.4419 58.0291 61.8153 57.5864 61.4851L56.3907 63.0883ZM83.3833 61.4672C82.9307 61.7837 82.8204 62.4072 83.1369 62.8598C83.4534 63.3124 84.0768 63.4227 84.5294 63.1063L83.3833 61.4672ZM93.5695 64.8572C93.8587 65.3278 94.4745 65.4748 94.9451 65.1857C95.4156 64.8965 95.5627 64.2807 95.2735 63.8101L93.5695 64.8572ZM66.2462 47.3676C65.6939 47.3676 65.2462 47.8153 65.2462 48.3676C65.2462 48.9199 65.6939 49.3676 66.2462 49.3676V47.3676ZM75.1013 49.3676C75.6536 49.3676 76.1013 48.9199 76.1013 48.3676C76.1013 47.8153 75.6536 47.3676 75.1013 47.3676V49.3676ZM70.6738 35.4955C70.0905 35.4955 69.5277 35.26 69.1099 34.8351L67.6838 36.2374C68.4739 37.0409 69.549 37.4955 70.6738 37.4955V35.4955ZM69.11 34.8352C68.6917 34.4097 68.4538 33.8292 68.4538 33.2204H66.4538C66.4538 34.3488 66.8944 35.4343 67.6838 36.2373L69.11 34.8352ZM68.4538 33.2204C68.4538 32.6116 68.6917 32.031 69.11 31.6056L67.6838 30.2035C66.8944 31.0065 66.4538 32.092 66.4538 33.2204H68.4538ZM69.1099 31.6057C69.5277 31.1808 70.0905 30.9453 70.6738 30.9453V28.9453C69.549 28.9453 68.4739 29.3999 67.6838 30.2034L69.1099 31.6057ZM70.6738 30.9453C71.2571 30.9453 71.82 31.1808 72.2377 31.6057L73.6638 30.2034C72.8737 29.3999 71.7986 28.9453 70.6738 28.9453V30.9453ZM72.2376 31.6056C72.6559 32.0311 72.8939 32.6116 72.8939 33.2204H74.8939C74.8939 32.092 74.4533 31.0065 73.6639 30.2035L72.2376 31.6056ZM72.8939 33.2204C72.8939 33.8292 72.6559 34.4098 72.2376 34.8352L73.6639 36.2373C74.4533 35.4343 74.8939 34.3488 74.8939 33.2204H72.8939ZM72.2377 34.8351C71.82 35.26 71.2571 35.4955 70.6738 35.4955V37.4955C71.7986 37.4955 72.8737 37.0409 73.6638 36.2374L72.2377 34.8351ZM49.951 57.7835C49.951 63.3636 52.1303 68.7183 56.0144 72.6692L57.4406 71.2671C53.9277 67.6938 51.951 62.844 51.951 57.7835H49.951ZM56.0144 72.6693C59.8996 76.6203 65.1721 78.8434 70.6737 78.8434V76.8434C65.7136 76.8434 60.9534 74.8395 57.4405 71.267L56.0144 72.6693ZM70.6737 78.8434C76.1754 78.8434 81.448 76.6203 85.333 72.6693L83.9069 71.267C80.3942 74.8395 75.6339 76.8434 70.6737 76.8434V78.8434ZM85.3331 72.6692C89.2172 68.7182 91.3965 63.3636 91.3965 57.7835H89.3965C89.3965 62.844 87.4198 67.6936 83.9069 71.2671L85.3331 72.6692ZM50.1225 57.2235L45.695 63.7737L47.3519 64.8937L51.7795 58.3435L50.1225 57.2235ZM50.3531 58.5851L56.3907 63.0883L57.5864 61.4851L51.5489 56.9819L50.3531 58.5851ZM89.8234 56.964L83.3833 61.4672L84.5294 63.1063L90.9695 58.603L89.8234 56.964ZM89.5445 58.307L93.5695 64.8572L95.2735 63.8101L91.2485 57.2599L89.5445 58.307ZM71.6737 77.8434V48.3676H69.6737V77.8434H71.6737ZM71.6737 48.3676L71.6738 36.4955L69.6738 36.4955L69.6737 48.3676L71.6737 48.3676ZM66.2462 49.3676H70.6737V47.3676H66.2462V49.3676ZM70.6737 49.3676H75.1013V47.3676H70.6737V49.3676Z" fill="#BDCBD6"/>
                <path d="M70.1082 14.6387C59.7931 14.6387 49.9013 18.7362 42.6075 26.0293C35.3144 33.3234 31.2168 43.2152 31.2168 53.53C31.2168 63.8448 35.3144 73.7369 42.6075 81.0307C49.9016 88.3238 59.7934 92.4214 70.1082 92.4214C80.423 92.4214 90.315 88.3238 97.6088 81.0307C104.902 73.7366 109 63.8448 109 53.53C109 43.2152 104.902 33.3232 97.6088 26.0293C90.3148 18.7362 80.423 14.6387 70.1082 14.6387Z" stroke="#BDCBD6" stroke-width="2"/>
              </svg>
              <p class="fz14 fw500 text-dark mt12">Loading ports are not added</p>
            </div>
            <div v-for="(port, k) in loading_ports" :key="k+'sad21312'">
              <div class="mb12" :class="{'mt24': k !== 0}">
                <p class="fz16 text-dark fw500 text-dots-overflow">Loading #{{getIndexPort(port)+1}} ({{port.name}}, {{port.country}})</p>
              </div>
              <div class="flex justify-between w100Proc">
                <div class="port-item">
                  <p class="m-b-1 fz13 text-gray-text">Vessel arrived load port</p>
                  <date-picker
                      :key="port.arrived_load_date"
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.arrived_load_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.arrived_load_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="loading_arrived_time" v-model="port.loading_arrived_time">

                  <p class="m-t-4 m-b-1 fz13 text-gray-text">Notice of Readiness  tendered</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.notice_tendered_loading_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.notice_tendered_loading_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="loading_notice_time" v-model="port.loading_notice_time">
                </div>
                <div class="port-item">
                  <p class="m-b-1 fz13 text-gray-text">Loading commenced</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.loading_commenced_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.loading_commenced_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="loading_commenced_time" v-model="port.loading_commenced_time">

                  <p class="m-t-4 m-b-1 fz13 text-gray-text">Loading completed</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.loading_completed_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.loading_completed_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="loading_completed_time" v-model="port.loading_completed_time">
                </div>
              </div>
            </div>

          </div>
          <div class="discharging position-relative">
            <div class="no-ports" v-if="!discharging_ports.length">
              <svg width="141" height="140" viewBox="0 0 141 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M106.978 81.1816H106.976M70.1108 2.83789C57.4953 2.83789 45.3331 7.54194 36.0004 16.0307C26.6681 24.5192 20.8367 36.1833 19.6446 48.7428C18.4534 61.3018 21.9879 73.8547 29.557 83.9462L68.268 135.561C68.7031 136.141 69.3861 136.483 70.1114 136.483C70.8366 136.483 71.5196 136.141 71.9547 135.561L110.666 83.9462C118.235 73.8539 121.769 61.301 120.578 48.7428C119.386 36.1839 113.554 24.5197 104.222 16.0307C94.8893 7.5422 82.7272 2.83789 70.1119 2.83789H70.1108Z" stroke="#BDCBD6" stroke-width="2"/>
                <path d="M68.3969 35.5363L67.6838 36.2373L67.6838 36.2374L68.3969 35.5363ZM68.3969 30.9045L67.6838 30.2034L67.6838 30.2035L68.3969 30.9045ZM72.9508 30.9045L73.6639 30.2035L73.6638 30.2034L72.9508 30.9045ZM72.9508 35.5363L73.6638 36.2374L73.6639 36.2373L72.9508 35.5363ZM50.951 57.7835L51.5489 56.9819C51.3298 56.8185 51.0534 56.7519 50.784 56.7975C50.5146 56.8432 50.2755 56.9971 50.1225 57.2235L50.951 57.7835ZM56.7275 71.9682L56.0144 72.6692L56.0144 72.6693L56.7275 71.9682ZM84.62 71.9682L85.333 72.6693L85.3331 72.6692L84.62 71.9682ZM90.3965 57.7835L91.2485 57.2599C91.1042 57.0252 90.8696 56.8604 90.5998 56.8044C90.3301 56.7484 90.0492 56.8061 89.8234 56.964L90.3965 57.7835ZM45.695 63.7737C45.3857 64.2312 45.5059 64.8529 45.9634 65.1622C46.421 65.4714 47.0426 65.3512 47.3519 64.8937L45.695 63.7737ZM56.3907 63.0883C56.8334 63.4185 57.46 63.3273 57.7902 62.8846C58.1204 62.4419 58.0291 61.8153 57.5864 61.4851L56.3907 63.0883ZM83.3833 61.4672C82.9307 61.7837 82.8204 62.4072 83.1369 62.8598C83.4534 63.3124 84.0768 63.4227 84.5294 63.1063L83.3833 61.4672ZM93.5695 64.8572C93.8587 65.3278 94.4745 65.4748 94.9451 65.1857C95.4156 64.8965 95.5627 64.2807 95.2735 63.8101L93.5695 64.8572ZM66.2462 47.3676C65.6939 47.3676 65.2462 47.8153 65.2462 48.3676C65.2462 48.9199 65.6939 49.3676 66.2462 49.3676V47.3676ZM75.1013 49.3676C75.6536 49.3676 76.1013 48.9199 76.1013 48.3676C76.1013 47.8153 75.6536 47.3676 75.1013 47.3676V49.3676ZM70.6738 35.4955C70.0905 35.4955 69.5277 35.26 69.1099 34.8351L67.6838 36.2374C68.4739 37.0409 69.549 37.4955 70.6738 37.4955V35.4955ZM69.11 34.8352C68.6917 34.4097 68.4538 33.8292 68.4538 33.2204H66.4538C66.4538 34.3488 66.8944 35.4343 67.6838 36.2373L69.11 34.8352ZM68.4538 33.2204C68.4538 32.6116 68.6917 32.031 69.11 31.6056L67.6838 30.2035C66.8944 31.0065 66.4538 32.092 66.4538 33.2204H68.4538ZM69.1099 31.6057C69.5277 31.1808 70.0905 30.9453 70.6738 30.9453V28.9453C69.549 28.9453 68.4739 29.3999 67.6838 30.2034L69.1099 31.6057ZM70.6738 30.9453C71.2571 30.9453 71.82 31.1808 72.2377 31.6057L73.6638 30.2034C72.8737 29.3999 71.7986 28.9453 70.6738 28.9453V30.9453ZM72.2376 31.6056C72.6559 32.0311 72.8939 32.6116 72.8939 33.2204H74.8939C74.8939 32.092 74.4533 31.0065 73.6639 30.2035L72.2376 31.6056ZM72.8939 33.2204C72.8939 33.8292 72.6559 34.4098 72.2376 34.8352L73.6639 36.2373C74.4533 35.4343 74.8939 34.3488 74.8939 33.2204H72.8939ZM72.2377 34.8351C71.82 35.26 71.2571 35.4955 70.6738 35.4955V37.4955C71.7986 37.4955 72.8737 37.0409 73.6638 36.2374L72.2377 34.8351ZM49.951 57.7835C49.951 63.3636 52.1303 68.7183 56.0144 72.6692L57.4406 71.2671C53.9277 67.6938 51.951 62.844 51.951 57.7835H49.951ZM56.0144 72.6693C59.8996 76.6203 65.1721 78.8434 70.6737 78.8434V76.8434C65.7136 76.8434 60.9534 74.8395 57.4405 71.267L56.0144 72.6693ZM70.6737 78.8434C76.1754 78.8434 81.448 76.6203 85.333 72.6693L83.9069 71.267C80.3942 74.8395 75.6339 76.8434 70.6737 76.8434V78.8434ZM85.3331 72.6692C89.2172 68.7182 91.3965 63.3636 91.3965 57.7835H89.3965C89.3965 62.844 87.4198 67.6936 83.9069 71.2671L85.3331 72.6692ZM50.1225 57.2235L45.695 63.7737L47.3519 64.8937L51.7795 58.3435L50.1225 57.2235ZM50.3531 58.5851L56.3907 63.0883L57.5864 61.4851L51.5489 56.9819L50.3531 58.5851ZM89.8234 56.964L83.3833 61.4672L84.5294 63.1063L90.9695 58.603L89.8234 56.964ZM89.5445 58.307L93.5695 64.8572L95.2735 63.8101L91.2485 57.2599L89.5445 58.307ZM71.6737 77.8434V48.3676H69.6737V77.8434H71.6737ZM71.6737 48.3676L71.6738 36.4955L69.6738 36.4955L69.6737 48.3676L71.6737 48.3676ZM66.2462 49.3676H70.6737V47.3676H66.2462V49.3676ZM70.6737 49.3676H75.1013V47.3676H70.6737V49.3676Z" fill="#BDCBD6"/>
                <path d="M70.1082 14.6387C59.7931 14.6387 49.9013 18.7362 42.6075 26.0293C35.3144 33.3234 31.2168 43.2152 31.2168 53.53C31.2168 63.8448 35.3144 73.7369 42.6075 81.0307C49.9016 88.3238 59.7934 92.4214 70.1082 92.4214C80.423 92.4214 90.315 88.3238 97.6088 81.0307C104.902 73.7366 109 63.8448 109 53.53C109 43.2152 104.902 33.3232 97.6088 26.0293C90.3148 18.7362 80.423 14.6387 70.1082 14.6387Z" stroke="#BDCBD6" stroke-width="2"/>
              </svg>
              <p class="fz14 fw500 text-dark mt12">Discharging ports are not added</p>
            </div>
            <div v-for="(port, k) in discharging_ports" :key="k+'kjh12312'">
              <div class="mb12" :class="{'mt24': k !== 0}">
                <p class="fz16 text-dark fw500 text-dots-overflow">Discharging #{{getIndexPort(port, 'discharging')+1}} ({{port.name}}, {{port.country}})</p>
              </div>
              <div class="flex justify-between w100Proc">
                <div class="port-item">
                  <p class="m-b-1 fz13 text-gray-text">Vessel arrived discharging port</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.arrived_discharging_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.arrived_discharging_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="discharging_arrived_time" v-model="port.discharging_arrived_time">

                  <p class="m-t-4 m-b-1 fz13 text-gray-text">Notice of Readiness  tendered</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.notice_tendered_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.notice_tendered_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="discharging_notice_time" v-model="port.discharging_notice_time">
                </div>
                <div class="port-item">
                  <p class="m-b-1 fz13 text-gray-text">Discharging commenced</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.discharging_commenced_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.discharging_commenced_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="discharging_commenced_time" v-model="port.discharging_commenced_time">

                  <p class="m-t-4 m-b-1 fz13 text-gray-text">Discharging completed</p>
                  <date-picker
                      class="lay_datepicker"
                      :class="{'lay_datepicker-value' : port.discharging_completed_date}"
                      format="DD.MM.YYYY"
                      value-type="format"
                      type="date"
                      placeholder="dd.mm.yyyy"
                      v-model="port.discharging_completed_date"
                  ></date-picker>
                  <input type="text" class="block-input_content m-t-2" placeholder="hh:mm" ref="discharging_completed_time" v-model="port.discharging_completed_time">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div 
          class="m-t-5 m-r-6 m-b-4"
          :class="{
            'm-r-6': !$route.meta.isCharter || (!smallScreen && !$route.meta.isCharter),
            'm-x-6': $route.meta.isCharter || (smallScreen && !$route.meta.isCharter)
          }"
        >
          <lay-table-head/>
          <lay-table :rows="rows" :arrived_time="getArrivedTime()" @changeDataList="changeDataList" :arrived_date="getArrivedDate()"/>
          <lay-table-total :rows="rows"/>

          <lay-total class="m-t-4" :rows="rows" :lay="lay" :timeAllowed="getTimeAllowed"/>
        </div>
      </div>
    </div>
    <div class="flex justify-end w-full m-t-auto p-x-6 p-y-2 bg-white box-border">
      <button class="p-x-12 m-r-16 fz14 fw500 text-blue-dark" @click="onCancel">Cancel</button>
      <button class="blue-button w-1/4 fz14 fw500 h32" @click="onSave">Save</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import DatePicker from 'vue2-datepicker'
import Inputmask from "inputmask"
import moment from "moment"

import layTableHead from '@/components/lay/edit/layTableHead'
import layTableTotal from '@/components/lay/edit/layTableTotal'
import layTable from '@/components/lay/edit/layTable'
import layTotal from '@/components/lay/edit/layTotal'
export default {
  components: {
    DatePicker,
    layTableHead,
    layTableTotal,
    layTable,
    layTotal
  },
  data() {
    return {
      smallScreen: false,
      rows: [],
      loading_arrived_time: '',
      loading_notice_time: '',
      loading_commenced_time: '',
      loading_completed_time: '',
      discharging_arrived_time: '',
      discharging_notice_time: '',
      discharging_commenced_time: '',
      discharging_completed_time: '',
      timeArr: [
        'loading_arrived_time', 
        'loading_notice_time', 
        'loading_commenced_time', 
        'loading_completed_time', 
        'discharging_arrived_time', 
        'discharging_notice_time', 
        'discharging_commenced_time', 
        'discharging_completed_time'
      ],
      loading_ports: [],
      discharging_ports: [],
    }
  },
  computed: {
    ...mapState({
      lay: state => state.lay.activeLay
    }),
    ...mapGetters(['getTimeAllowed'])
  },
  methods: {
    ...mapActions(['checkLayEdit', 'axiosPutLay']),
    ...mapMutations(['changeContractBread', 'showLoad', 'hideLoad']),
    getIndexPort(port, namePort) {
      let id = port?.PORT_ID ? port.PORT_ID : null
      if(namePort === 'discharging') {
        return this.lay.lay_ports.findIndex(a=> a.id === id)
      } else {
        return this.lay.lay_ports.findIndex(a=> a.id === id)
      }
    },
    // changeDataList(index) {
    //   let rows = JSON.parse(JSON.stringify(this.rows))
    //   let firstPart = JSON.parse(JSON.stringify(rows)).splice(0, index)
    //   let secondPart = JSON.parse(JSON.stringify(rows)).splice(index+1, rows.length)
    //   secondPart.forEach((item, i)=> {
    //     if( i === 0) {
    //       if(rows[index].to_date === '24:00') {
    //           item.date = moment(rows[index].date, 'DD.MM.YYYY').add(1, 'days').format('DD.MM.YYYY')
    //       } else {
    //           item.date = rows[index].date;
    //       }
    //     } else {
    //       if(secondPart[i-1].to_date === '24:00') {
    //           item.date = moment(secondPart[i-1].date, 'DD.MM.YYYY').add(1, 'days').format('DD.MM.YYYY')
    //       } else {
    //         item.date = secondPart[i-1].date
    //       }
    //     }
    //     if(item.date && item.date !== null && item.date !== undefined && item.date !== 'Invalid date') {
    //       if(item.date !== 'Invalid date') {
    //         item.day = moment(item.date, 'DD.MM.YYYY').format('ddd')
    //         if(item.day === 'Invalid date') {
    //           item.date = ''
    //         }
    //       } else {
    //         item.day = ''
    //         item.date = ''
    //       }
    //     } else {
    //       item.day = ''
    //       item.date = ''
    //     }
    //   })
    //   firstPart = firstPart.reverse()
    //   firstPart.forEach((item, i)=> {
    //     if(i === 0) {
    //       if(rows[index].from_date === '00:00') {
    //           item.date = moment(rows[index].date, 'DD.MM.YYYY').add(-1, 'days').format('DD.MM.YYYY')
    //       } else {
    //         item.date = rows[index].date;
    //       }
    //     } else {
    //       if(firstPart[i-1].from_date === '00:00') {
    //           item.date = moment(firstPart[i-1].date, 'DD.MM.YYYY').add(-1, 'days').format('DD.MM.YYYY')
    //       } else {
    //         item.date = firstPart[i-1].date
    //       }
    //     }
    //     if(item.date && item.date !== null && item.date !== undefined) {
    //       if(item.date !== 'Invalid date') {
    //         item.day = moment(item.date, 'DD.MM.YYYY').format('ddd')
    //         if(item.day === 'Invalid date') {
    //           item.date = ''
    //         }
    //       } else {
    //         item.day = ''
    //         item.date = ''
    //       }
    //     } else {
    //       item.day = ''
    //       item.date = ''
    //     }
    //   })
    //   firstPart = firstPart.reverse()
    //   firstPart = firstPart.concat([rows[index]])
    //   this.rows = firstPart.concat(secondPart)
    // },
    changeDataList(index) {
  const clone = data => JSON.parse(JSON.stringify(data));
  const isValidDate = date => moment(date, 'DD.MM.YYYY').isValid();
  const formatDate = date => moment(date, 'DD.MM.YYYY').format('ddd');

  const originalRows = clone(this.rows);
  const current = clone(originalRows[index]);

  const firstPart = clone(originalRows.slice(0, index)).reverse();
  const secondPart = clone(originalRows.slice(index + 1));

  // Обробка firstPart ← назад
  for (let i = 0; i < firstPart.length; i++) {
    const nextItem = i === 0 ? current : firstPart[i - 1];

    firstPart[i].date =
      firstPart[i].to_date === '24:00'
        ? moment(nextItem.date, 'DD.MM.YYYY').subtract(1, 'days').format('DD.MM.YYYY')
        : nextItem.date;

    firstPart[i].day = isValidDate(firstPart[i].date) ? formatDate(firstPart[i].date) : '';
  }

  // Обробка secondPart → вперед
  for (let i = 0; i < secondPart.length; i++) {
    const prevItem = i === 0 ? current : secondPart[i - 1];

    secondPart[i].date =
      prevItem.to_date === '24:00'
        ? moment(prevItem.date, 'DD.MM.YYYY').add(1, 'days').format('DD.MM.YYYY')
        : prevItem.date;

    secondPart[i].day = isValidDate(secondPart[i].date) ? formatDate(secondPart[i].date) : '';
  }

  // Повертаємо всі частини в єдине ціле
  this.rows = [...firstPart.reverse(), current, ...secondPart];
},


    getArrivedTime() {
      // if(Array.isArray(this.loading_ports) === true && this.loading_ports?.length !== 0) {
      //   return ''+this.loading_ports[0].loading_arrived_time;
      // } else if(Array.isArray(this.discharging_ports) === true && this.discharging_ports?.length !== 0) {
      //   return ''+this.discharging_ports[0].discharging_arrived_time;
      // }
      // return ''

      if(Array.isArray(this.lay.lay_ports) === true && this.lay.lay_ports.length !== 0) {
        if(this.lay.lay_ports[0].loading_port) {
          let item = this.loading_ports.find(a=> a.loading_port_id === this.lay.lay_ports[0].loading_port.id)
          if(item) {
            return item.loading_arrived_time
          }
        } else if(this.lay.lay_ports[0].discharging_port) {
          let item = this.discharging_ports.find(a=> a.discharging_port_id === this.lay.lay_ports[0].discharging_port.id)
          if(item) {
            return item.discharging_arrived_time
          }
        }
      }
      return ''
    },
    getArrivedDate() {
     if(Array.isArray(this.lay.lay_ports) === true && this.lay.lay_ports.length !== 0) {
       if(this.lay.lay_ports[0].loading_port) {
         let item = this.loading_ports.find(a=> a.loading_port_id === this.lay.lay_ports[0].loading_port.id)
         if(item) {
           return item.arrived_load_date
         }
       } else if(this.lay.lay_ports[0].discharging_port) {
         let item = this.discharging_ports.find(a=> a.discharging_port_id === this.lay.lay_ports[0].discharging_port.id)
         if(item) {
           return item.arrived_discharging_date
         }
       }
     }
      return ''
      // if(Array.isArray(this.loading_ports) === true && this.loading_ports?.length !== 0) {
      //   return ''+this.loading_ports[0].arrived_load_date;
      // } else if(Array.isArray(this.discharging_ports) === true && this.discharging_ports?.length !== 0) {
      //   return ''+this.discharging_ports[0].arrived_discharging_date;
      // }
      // return ''
    },
    checkTime(obj, date, time) {
      if(obj[date] && time){
        obj[date] = moment(obj[date] + ' ' + time, 'DD.MM.YYYY hh:mm').format('YYYY-MM-DD HH:mm')
      } else if(obj[date]){
        obj[date] = moment(obj[date], 'DD.MM.YYYY').format('YYYY-MM-DD HH:mm')
      }
    },
    checkTimes(obj) {
      this.checkTime(obj, 'arrived_load_date', this.loading_arrived_time)
      this.checkTime(obj, 'notice_tendered_loading_date', this.loading_notice_time)
      this.checkTime(obj, 'loading_commenced_date', this.loading_commenced_time)
      this.checkTime(obj, 'loading_completed_date', this.loading_completed_time)
      this.checkTime(obj, 'arrived_discharging_date', this.discharging_arrived_time)
      this.checkTime(obj, 'notice_tendered_date', this.discharging_notice_time)
      this.checkTime(obj, 'discharging_commenced_date', this.discharging_commenced_time)
      this.checkTime(obj, 'discharging_completed_date', this.discharging_completed_time)
    },
    setTimesPorts() {
      this.lay.additional_info['loading_ports'] = this.loading_ports;
      this.lay.additional_info['discharging_ports'] = this.discharging_ports;
      if(this.lay.additional_info?.loading_ports?.length) {
        this.lay.additional_info.loading_ports.forEach(item=> {
          this.checkTime(item, 'arrived_load_date', item.loading_arrived_time)
          this.checkTime(item, 'notice_tendered_loading_date', item.loading_notice_time)
          this.checkTime(item, 'loading_commenced_date', item.loading_commenced_time)
          this.checkTime(item, 'loading_completed_date', item.loading_completed_time)
        })
      }
      if(this.lay.additional_info?.discharging_ports?.length) {
        this.lay.additional_info.discharging_ports.forEach(item=> {
          this.checkTime(item, 'arrived_discharging_date', item.discharging_arrived_time)
          this.checkTime(item, 'notice_tendered_date', item.discharging_notice_time)
          this.checkTime(item, 'discharging_commenced_date', item.discharging_commenced_time)
          this.checkTime(item, 'discharging_completed_date', item.discharging_completed_time)
        })
      }
    },
    async onSave() {
      this.checkTimes(this.lay)
      this.setTimesPorts()

      let saveObj = JSON.parse(JSON.stringify(this.lay))
      saveObj.contract = saveObj.contract.id
      saveObj.owner = saveObj.owner ? saveObj.owner.id : null;
      saveObj.lay_ports.forEach(el => {
        if(el.discharging_port){
          el.discharging_port = el.discharging_port.id
        }
        if(el.loading_port){
          el.loading_port = el.loading_port.id
        }
      })

      saveObj.lay_times = []
      this.rows.forEach(el => {
        let obj = {...el}
        obj.date = obj.date ? moment(obj.date, 'DD.MM.YYYY').format('YYYY-MM-DD HH:mm') : null
        saveObj.lay_times.push(obj)
      })
      console.log(saveObj)
      this.showLoad()
      await this.axiosPutLay(saveObj)
      this.hideLoad()
      if(!this.$route.meta.isCharter)
        this.$router.push(`/vessels/${this.$route.params.id}/open/lay/details`)
      else
        this.$router.push(`/vessels/${this.$route.params.id}/open/charterers/${this.$route.params.subId}/lay/details`)
    },
    onCancel() {
      this.$router.back()
    },
    addInputMask() {
      this.timeArr.forEach(el=>{
        if(Array.isArray(this.$refs[el])) {
          this.$refs[el].forEach((item, index)=> {
            if (this.$refs[el][index] && !this.$refs[el][index].inputmask)
              Inputmask({ regex: "(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])", "clearIncomplete": true }).mask(this.$refs[el][index])
          })
        }
      })
    },
    setLoadDates() {
      if(this.lay.arrived_load_date){
        this.loading_arrived_time = moment(new Date(this.lay.arrived_load_date)).format('HH:mm')
        this.lay.arrived_load_date = moment(new Date(this.lay.arrived_load_date)).format('DD.MM.YYYY')
      }
      if(this.lay.notice_tendered_loading_date){
        this.loading_notice_time = moment(new Date(this.lay.notice_tendered_loading_date)).format('HH:mm')
        this.lay.notice_tendered_loading_date = moment(new Date(this.lay.notice_tendered_loading_date)).format('DD.MM.YYYY')
      }

      if(this.lay.loading_commenced_date){
        this.loading_commenced_time = moment(new Date(this.lay.loading_commenced_date)).format('HH:mm')
        this.lay.loading_commenced_date = moment(new Date(this.lay.loading_commenced_date)).format('DD.MM.YYYY')
      }
      if(this.lay.loading_completed_date){
        this.loading_completed_time = moment(new Date(this.lay.loading_completed_date)).format('HH:mm')
        this.lay.loading_completed_date = moment(new Date(this.lay.loading_completed_date)).format('DD.MM.YYYY')
      }

      if(this.lay.arrived_discharging_date){
        this.discharging_arrived_time = moment(new Date(this.lay.arrived_discharging_date)).format('HH:mm')
        this.lay.arrived_discharging_date = moment(new Date(this.lay.arrived_discharging_date)).format('DD.MM.YYYY')
      }
      if(this.lay.notice_tendered_date){
        this.discharging_notice_time = moment(new Date(this.lay.notice_tendered_date)).format('HH:mm')
        this.lay.notice_tendered_date = moment(new Date(this.lay.notice_tendered_date)).format('DD.MM.YYYY')
      }

      if(this.lay.discharging_commenced_date){
        this.discharging_commenced_time = moment(new Date(this.lay.discharging_commenced_date)).format('HH:mm')
        this.lay.discharging_commenced_date = moment(new Date(this.lay.discharging_commenced_date)).format('DD.MM.YYYY')
      }
      if(this.lay.discharging_completed_date){
        this.discharging_completed_time = moment(new Date(this.lay.discharging_completed_date)).format('HH:mm')
        this.lay.discharging_completed_date = moment(new Date(this.lay.discharging_completed_date)).format('DD.MM.YYYY')
      }
    },
    setLoadDatesPorts() {
      this.loading_ports.forEach(item=> {
        item.arrived_load_date = item.arrived_load_date ?  moment(new Date(item.arrived_load_date)).format('DD.MM.YYYY') : ''
        item.notice_tendered_loading_date = item.notice_tendered_loading_date ?  moment(new Date(item.notice_tendered_loading_date)).format('DD.MM.YYYY') : ''
        item.loading_commenced_date = item.loading_commenced_date ? moment(new Date(item.loading_commenced_date)).format('DD.MM.YYYY') : ''
        item.loading_completed_date = item.loading_completed_date ? moment(new Date(item.loading_completed_date)).format('DD.MM.YYYY') : ''

      })
      this.discharging_ports.forEach(item=> {
        item.arrived_discharging_date = item.arrived_discharging_date ? moment(new Date(item.arrived_discharging_date)).format('DD.MM.YYYY') : ''
        item.notice_tendered_date = item.notice_tendered_date ? moment(new Date(item.notice_tendered_date)).format('DD.MM.YYYY') : ''
        item.discharging_commenced_date = item.discharging_commenced_date ? moment(new Date(item.discharging_commenced_date)).format('DD.MM.YYYY') : ''
        item.discharging_completed_date = item.discharging_completed_date ? moment(new Date(item.discharging_completed_date)).format('DD.MM.YYYY') : ''
      })
    },
    onBlurDemurrage() {
      if(this.lay.demurrage_rate)
        this.lay.dispatch_rate = Math.round((this.lay.demurrage_rate/2)*10000000)/10000000
      else
        this.lay.dispatch_rate = 0
    },
    onBlurDispatch() {
      if(this.lay.dispatch_rate)
        this.lay.demurrage_rate = Math.round((this.lay.dispatch_rate*2)*10000000)/10000000
      else
        this.lay.demurrage_rate = 0
    }
  },
  async beforeMount() {
    // if(document.documentElement.clientWidth <=1370) {
    //   this.smallScreen = true
    // } else {
    //   this.smallScreen = false
    // }
    // window.addEventListener('resize', ()=> {
    //   if(document.documentElement.clientWidth <=1370) {
    //     this.smallScreen = true
    //   } else {
    //     this.smallScreen = false
    //   }
    // });
    await this.checkLayEdit(this.$route.params.id)

    if(this.lay){
      if(!this.$route.meta.isCharter){
        this.changeContractBread({
          index: 2,
          obj: {
            name: `Edit LayTime Table (
              ${this.lay.lay_ports[0].loading_port ? this.lay.lay_ports[0].loading_port.name+', '+this.lay.lay_ports[0].loading_port.country:''} 
              ${this.lay.lay_ports[0].loading_port && this.lay.lay_ports[0].discharging_port ? '-':''} 
              ${this.lay.lay_ports[0].discharging_port ? this.lay.lay_ports[0].discharging_port.name+', '+this.lay.lay_ports[0].discharging_port.country:''}
              
              ${this.lay.lay_ports.length > 1 ? ', +'+(this.lay.lay_ports.length-1) : ''})`,
            link: `/vessels/`
          }
        })
      }

      await this.$nextTick()

      this.setLoadDates()
      
      let rowsArr = [...this.lay.lay_times]

      rowsArr.forEach(row => {
        row.date = row.date ? moment(row.date).format('DD.MM.YYYY') : ''
      })

      const sortedRows = rowsArr.sort((a, b) => {
        const dateA = moment(a.date, 'DD.MM.YYYY');
        const dateB = moment(b.date, 'DD.MM.YYYY');

        // спочатку по даті
        if (!dateA.isSame(dateB, 'day')) {
          return dateA.diff(dateB);
        }

        // якщо дата однакова — по часу from_date
        const timeA = moment(a.from_date, 'HH:mm');
        const timeB = moment(b.from_date, 'HH:mm');

        return timeA.diff(timeB);
      });
      this.rows = sortedRows
      this.loading_ports = this.lay.additional_info?.loading_ports?.length ? this.lay.additional_info.loading_ports : []
      this.discharging_ports = this.lay.additional_info?.discharging_ports?.length ? this.lay.additional_info.discharging_ports : []
      console.log('loading_ports', this.loading_ports, 'discharging_ports', this.discharging_ports)
      if(!this.loading_ports.length) {
        let loading_ports = [];
        this.lay.lay_ports.forEach((item, index)=> {
          if(item.loading_port) {
            loading_ports.push({
              id_port: index,
              PORT_ID: item.id,
              loading_port_id: item.loading_port.id,
              arrived_load_date: '',
              loading_arrived_time: '',
              notice_tendered_loading_date: '',
              loading_notice_time: '',
              loading_commenced_date: '',
              loading_commenced_time: '',
              loading_completed_date: '',
              loading_completed_time: '',
              name: item.loading_port.name,
              country: item.loading_port.country,
            })
          }
        })
        this.loading_ports = loading_ports;
      } else if(this.loading_ports.length) {
        this.loading_ports.forEach((item, index)=> {
          let data = this.lay.lay_ports[item.id_port];
          let indexData = item.id_port;
          if(data) {
            // indexData !== item.loading_port_id
            if(data.loading_port && data.loading_port.id !== item.loading_port_id) {
              this.loading_ports[index] = {
                id_port: indexData,
                PORT_ID: data.id,
                loading_port_id: data.loading_port.id,
                arrived_load_date: '',
                loading_arrived_time: '',
                notice_tendered_loading_date: '',
                loading_notice_time: '',
                loading_commenced_date: '',
                loading_commenced_time: '',
                loading_completed_date: '',
                loading_completed_time: '',
                name: data.loading_port.name,
                country: data.loading_port.country,
              }
            } else {
              if(!item.PORT_ID || item.PORT_ID !== data.id) {
                item.PORT_ID = data.id
              }
            }
          } else {
            this.loading_ports = this.loading_ports.filter(a=> a.id_port !== item.id_port)
          }
        })
      }
      this.loading_ports = JSON.parse(JSON.stringify(this.loading_ports))


      if(!this.discharging_ports.length) {
        let discharging_ports = [];
        this.lay.lay_ports.forEach((item, index)=> {
          if(item.discharging_port) {
            discharging_ports.push({
              id_port: index,
              PORT_ID: item.id,
              discharging_port_id: item.discharging_port.id,
              arrived_discharging_date: '',
              discharging_arrived_time: '',
              notice_tendered_date: '',
              discharging_notice_time: '',
              discharging_commenced_date: '',
              discharging_commenced_time: '',
              discharging_completed_date: '',
              discharging_completed_time: '',
              name: item.discharging_port.name,
              country: item.discharging_port.country,
            })
          }
        })
        this.discharging_ports = discharging_ports;
      } else if(this.discharging_ports.length) {
        this.discharging_ports.forEach((item, index)=> {
          let data = this.lay.lay_ports[item.id_port];
          let indexData = item.id_port;
          if(data) {
          // || indexData !== item.id_port
            if(data.discharging_port && data.discharging_port.id !== item.discharging_port_id) {
              this.discharging_ports[index] = {
                id_port: indexData,
                PORT_ID: data.id,
                discharging_port_id: data.discharging_port.id,
                arrived_discharging_date: '',
                discharging_arrived_time: '',
                notice_tendered_date: '',
                discharging_notice_time: '',
                discharging_commenced_date: '',
                discharging_commenced_time: '',
                discharging_completed_date: '',
                discharging_completed_time: '',
                name: data.discharging_port.name,
                country: data.discharging_port.country,
              }
            } else {
              if(!item.PORT_ID || item.PORT_ID !== data.id) {
                item.PORT_ID = data.id
              }
            }
          } else {
            this.discharging_ports = this.discharging_ports.filter(a=> a.id_port !== item.id_port)
          }
        })
      }
      this.discharging_ports = JSON.parse(JSON.stringify(this.discharging_ports))

    }

    this.lay.lay_ports.forEach((item, index)=> {
      let data = this.loading_ports.find(a=>{return a.id_port == index})
      console.log(data, this.loading_ports, index, item)
      if(!data && item.loading_port) {
        this.loading_ports.push({
          id_port: index,
          PORT_ID: item.id,
          loading_port_id: item.loading_port.id,
          arrived_load_date: '',
          loading_arrived_time: '',
          notice_tendered_loading_date: '',
          loading_notice_time: '',
          loading_commenced_date: '',
          loading_commenced_time: '',
          loading_completed_date: '',
          loading_completed_time: '',
          name: item.loading_port.name,
          country: item.loading_port.country,
        })
      } if (data && !item.loading_port) {
        this.loading_ports = this.loading_ports.filter(a=> a.id_port != index)
      }
      data = this.discharging_ports.find(a=>{return a.id_port == index})
      if(!data && item.discharging_port) {
        this.discharging_ports.push({
          id_port: index,
          PORT_ID: item.id,
          discharging_port_id: item.discharging_port.id,
          arrived_discharging_date: '',
          discharging_arrived_time: '',
          notice_tendered_date: '',
          discharging_notice_time: '',
          discharging_commenced_date: '',
          discharging_commenced_time: '',
          discharging_completed_date: '',
          discharging_completed_time: '',
          name: item.discharging_port.name,
          country: item.discharging_port.country,
        })
      } if (data && !item.discharging_port) {
        this.discharging_ports = this.discharging_ports.filter(a=> a.id_port != index)
      }
    })
    this.loading_ports.sort((a, b) => a.id_port > b.id_port ? 1 : -1);
    this.discharging_ports.sort((a, b) => a.id_port > b.id_port ? 1 : -1);

    this.setLoadDatesPorts()
    setTimeout(()=> {this.addInputMask()}, 400)

  },
  beforeDestroy() {
    this.changeContractBread({
      index: 2,
      obj: null
    })
  }
}
</script>

<style lang="scss">
.lay_datepicker{
  width: 100%;
  .mx-input{
    padding-left: 0.75rem !important;
    background-position: calc(100% - 0.5rem) center;
  }
  .mx-icon-calendar{
    display: none;
  }
  &-value {
    &:hover {
      input {
        background-image: none !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.block-ports {
  .loading, .discharging {
    min-height: 212px;
    width: calc(50% - 13px);
    .port-item {
      width: calc(50% - 13px);
    }
  }
  border: 1px solid var(--color-border);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  /deep/ {
    .mx-input {
      background-color: var(--color-input) !important;
    }
  }
  .no-ports {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      width: max-content;
    }
  }
}
</style>